import watch from 'redux-watch';
import { GridController } from "../../../../../common/grid/grid.controller";

/* @ngInject */
export function ProtectiveEquipmentTestReportsGridController($controller, $ngRedux, $state, $rootScope, NavigationService, ProtectiveEquipmentActions, ProtectiveEquipmentTestService) {
    var ctrl = this;

    Object.setPrototypeOf(ctrl, new GridController($ngRedux, $state, NavigationService));

    ctrl.$onInit = function() {
        ctrl.module = 'protectiveEquipment';
        ctrl.identifier = 'protectiveEquipmentTestReportsGrid';
        ctrl.filterTemplate = './protective-equipment-test-reports-grid-filter.html';
        ctrl.exportService = ProtectiveEquipmentTestService.getPersonalEquipmentTests;

        ctrl.columns = [
            {title: '#',                        mapper: null},
            {title: 'Equipment ID',             mapper: 'ppeEquipmentId'},
            {title: 'Location',                 mapper: 'location'},
            {title: 'Type',                     mapper: 'equipmentType'},
            {title: 'Lead Equivalence',         mapper: 'getEquipmentLeadEquivalence'},
            {title: 'Annual Visual Results',    mapper: 'annualVisualResults'},
            {title: 'Annual Screening Result',  mapper: 'annualScreeningResultDesc'},
            {title: 'Tested Date',              mapper: 'getTestDate'},
            {title: 'Due Date',                 mapper: 'getDueDate'},
            {title: 'Tested by',                mapper: 'tester.getFullName'}
        ];

        ctrl.unsubscribe = $ngRedux.connect(ctrl.mapState().bind(ctrl), ProtectiveEquipmentActions)(ctrl);
        ctrl.dataAction = ctrl.getProtectiveEquipmentTestReports;
        ctrl.init.call(ctrl);
    };

    var watchStatus = watch($ngRedux.getState, 'protectiveEquipment.protectiveEquipmentTestReportsGrid.filter.location');
    var onChangeLocation = $ngRedux.subscribe(watchStatus(function(newValue) {
        if (ctrl.filter.category) {
            ctrl.getProtectiveEquipmentTypes(ctrl.filter.category, newValue);
        }
        ctrl.$ngRedux.dispatch({
            type: 'SUBTYPE_LIST',
            id: 'equipment',
            data: null
        });
        ctrl.$ngRedux.dispatch({
            type: 'INPUT_SELECT',
            id: 'protectiveEquipmentTestReportsGrid',
            path: 'filter.type',
            input: null
        });
        ctrl.$ngRedux.dispatch({
            type: 'INPUT_SELECT',
            id: 'protectiveEquipmentTestReportsGrid',
            path: 'filter.subtype',
            input: null
        });
    }));

    var watchReset = watch($ngRedux.getState, 'protectiveEquipment.protectiveEquipmentTestReportsGrid.reset');
    var onReset = $ngRedux.subscribe(watchReset(function() {
        $rootScope.$broadcast('SELECT_CASCADE_RESET', 'protectiveEquipmentTestsFilterForm');
        ctrl.$ngRedux.dispatch({
            type: 'TYPE_LIST',
            id: 'equipment',
            data: null
        });
        ctrl.$ngRedux.dispatch({
            type: 'SUBTYPE_LIST',
            id: 'equipment',
            data: null
        });
    }));

    ctrl.filterActions.onCategorySelected = (event) => {
        ctrl.getProtectiveEquipmentTypes(event.input, ctrl.filter.location);
        ctrl.$ngRedux.dispatch({
            type: 'SUBTYPE_LIST',
            id: 'equipment',
            data: []
        });
        ctrl.$ngRedux.dispatch({
            type: 'INPUT_SELECT',
            id: 'protectiveEquipmentTestReportsGrid',
            path: 'filter.type',
            input: null
        });
        ctrl.$ngRedux.dispatch({
            type: 'INPUT_SELECT',
            id: 'protectiveEquipmentTestReportsGrid',
            path: 'filter.subtype',
            input: null
        });
        $ngRedux.dispatch({
            type: 'GRID_RELOAD',
            id: 'protectiveEquipmentTestReportsGrid'
        });
    };

    ctrl.filterActions.onTypeSelected = (event) => {
        ctrl.getProtectiveEquipmentSubtypes(event.input, ctrl.filter.location);
        ctrl.$ngRedux.dispatch({
            type: 'INPUT_SELECT',
            id: 'protectiveEquipmentTestReportsGrid',
            path: 'filter.subtype',
            input: null
        });
        $ngRedux.dispatch({
            type: 'GRID_RELOAD',
            id: 'protectiveEquipmentTestReportsGrid'
        });
    };

    ctrl.$onDestroy = function() {
        onReset();
        onChangeLocation();
        ctrl.destroy();
        this.$ngRedux.dispatch({
            type: 'GRID_RESET',
            id: 'protectiveEquipmentTestReportsGrid',
        });
        ctrl.$ngRedux.dispatch({
            type: 'TYPE_LIST',
            id: 'equipment',
            data: []
        });
        ctrl.$ngRedux.dispatch({
            type: 'SUBTYPE_LIST',
            id: 'equipment',
            data: []
        });
    };
}
